import axios from 'axios';

export default {
    /**
     * Загружает список доступных способов доставки
     * @param {Object} params
     * @param success
     * @param failure
     * @returns {Promise<void>}
     */
    async loadAvailableDeliveries(params, success, failure) {
        await axios
            .get('/api/order/deliveries/', {params})
            .then((res) => {
                success(res.data);
            })
            .catch(err => failure(err));
    },

    /**
     * Загружает список доступных способов оплаты
     * @param params
     * @param success
     * @param failure
     * @returns {Promise<void>}
     */
    async loadAvailablePaySystems(params, success, failure) {
        await axios
            .get('/api/order/paysystems/', {params})
            .then(res => {
                success(res.data);
            })
            .catch(err => failure(err));
    },

    /**
     * Загружает информацию о заказе
     * @param params
     * @param success
     * @param failure
     * @returns {Promise<void>}
     */
    async loadOrderSummary(params, success, failure) {
        await axios
            .get('/api/order/summary/', {params})
            .then(res => {
                success(res.data);
            })
            .catch(err => failure(err));
    },

    /**
     * Сохраняет заказ
     * @param params
     * @param success
     * @param failure
     * @returns {Promise<void>}
     */
    async saveOrder(params, success, failure) {
        await axios
            .post('/api/order/save/', params)
            .then(res => success(res.data))
            .catch(err => failure(err));
    }
};